module.exports = __webpack_public_path__ + "img/log-in-login.3a585885.jpg";